import { NgModule } from '@angular/core';
import {
  AccountLockButton,
  AccountMenuSelectionUtils,
  AccountMenuComboSelectionUtils,
  ConfettiUtil,
  DimmerUtils,
  FormattedDateComponent,
  ImageLoaderFlagUtils,
  ImageLoaderUtils,
  SocialMediaUtils,
  SpinnerUtils,
  SportIconOnTv,
  TeamUniformUtils,
  LeagueUtils,
} from '@app/utils/utils';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@app/modules/shared.module';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { FormsModule } from '@angular/forms';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { TranslateModule } from '@ngx-translate/core';
import { FavTournamentsComponent } from '@components/fav-tournaments.component';
import { MaterialImports } from '@environments/environment';

@NgModule({
  declarations: [
    SpinnerUtils,
    AccountLockButton,
    AccountMenuSelectionUtils,
    AccountMenuComboSelectionUtils,
    ImageLoaderUtils,
    ImageLoaderFlagUtils,
    SocialMediaUtils,
    DimmerUtils,
    TeamUniformUtils,
    LeagueUtils,
    SportIconOnTv,
    FormattedDateComponent,
    ConfettiUtil,
    FavTournamentsComponent,
  ],
  providers: [],
  exports: [
    SpinnerUtils,
    AccountLockButton,
    AccountMenuSelectionUtils,
    AccountMenuComboSelectionUtils,
    ImageLoaderUtils,
    ImageLoaderFlagUtils,
    SocialMediaUtils,
    DimmerUtils,
    TeamUniformUtils,
    LeagueUtils,
    SportIconOnTv,
    FormattedDateComponent,
    ConfettiUtil,
    FavTournamentsComponent,
  ],
  imports: [CommonModule, SharedModule, MatProgressBarModule, FormsModule, AngularSvgIconModule, LazyLoadImageModule, TranslateModule, MaterialImports],
})
export class UtilsModule {}
